import React from "react";
import styled from "styled-components";

const Btn = styled.button`
  display: block;
  background: #500;
  padding: 4px;
  color: white;
  border-radius: 3px;
`;

const newUser = props => {
  const { currentlyLoggedInUser: user } = props;

  return (
    <div>
      Velkommen til SKK du er logget ind men har pt. ingen rettigheder.
      <pre>
        Provider: {user.providerData[0].providerId} <br />
        UID: {user.uid} <br />
        ID: {user.ID} <br />
        Navn: {user.displayName}
      </pre>
      <img width={40} src={user.photoURL} alt="profile" />
      <Btn
        onClick={() => {
          window.history.pushState(null, null, "#/");
          window.location.reload();
          // window.history.go()
        }}
      >
        Prøv igen!
      </Btn>
      <Btn
        onClick={() => {
          window.history.pushState(null, null, "#/logout");
          window.location.reload();
          // window.history.go()
        }}
      >
        Log ud
      </Btn>
    </div>
  );
};

export default newUser;
